<template>
  <div class="mb-5">
    <v-card flat outlined :loading="isLoading || isMainLoading" min-height="30">
      <v-card-title>
        <h2>Overview</h2>
      </v-card-title>
      <v-card-text>
        <div class="dashboard">
          <div class="dashboard-header">
            <div class="head">{{ $t('market.market_title') }}</div>
            <div>{{ $t('in_current_month') }}</div>
            <div class="tail">{{ $t('area.stall_data') }}</div>
          </div>
          <div class="dashboard-box">
            <div class="icon-box">
              <div class="image-icon area">
                <img class src="@/assets/images/area-icon.png" alt="area-icon" />
              </div>
            </div>
            <div>{{ $t('market.market_title') }}</div>
            <template v-if="!isLoading && dataAreaPrepare">
              <div class="h-number">{{ $helper.toArabic(dataAreaPrepare.count || 0) }}</div>
              <div>{{ $t('area.area_of_market', { count: $helper.toCurrency(dataAreaPrepare.size || 0) }) }}</div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
          <div class="dashboard-box">
            <div class="icon-box">
              <v-icon class="renter">mdi-home-account</v-icon>
            </div>
            <div>{{ $t('area.renter') }}</div>
            <template v-if="!isLoading && dataAreaPrepare">
              <div class="h-number">
                {{ $helper.toArabic(dataAreaPrepare.countOccupied || 0) }}
                <span>({{ $helper.toCurrency((dataAreaPrepare.percentOccupied * 100) || 0) }}%)</span>
              </div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div>{{ $t('area.renter_all', { count: $helper.toArabic(dataAreaPrepare.countOccupied || 0) }) }}</div>
                    <div>{{ $t('area.renter_percentage', { count: $helper.toCurrency((dataAreaPrepare.percentOccupied * 100) || 0) }) }}</div>
                    <div class="ml-5">
                      <div>{{ $t('area.from_renter_day', { count: $helper.toArabic(dataAreaPrepare.countAreaBooking || 0) }) }}</div>
                      <div>{{ $t('contract.from_renter_contract', { count: $helper.toArabic(dataAreaPrepare.countContract || 0) }) }}</div>
                    </div>
                    <template v-if="dataAreaPrepare.lastMonthData">
                      <br />
                      <div>{{ $t('area.new_renter_in_month', { month: dataAreaPrepare.lastMonth, count: $helper.toArabic(dataAreaPrepare.lastMonthData.count || 0) }) }}</div>
                      <div class="ml-5">
                        <div>{{ $t('area.from_renter_day', { count: $helper.toArabic(dataAreaPrepare.lastMonthData.countAreaBooking || 0) }) }}</div>
                        <div>{{ $t('contract.from_renter_contract', { count: $helper.toArabic(dataAreaPrepare.lastMonthData.countContract || 0) }) }}</div>
                      </div>
                    </template>
                  </div>
                </v-tooltip>
                <template v-if="dataAreaPrepare.lastMonthData && dataAreaPrepare.lastMonthData.count > 0">
                  {{ $t('new') }}
                  <span class="plus">+{{ $helper.toArabic(dataAreaPrepare.lastMonthData.count || 0) }}</span>
                </template>
                <template v-else>{{ $t('area.no_renter') }}</template>
              </div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
          <div class="dashboard-box">
            <div class="icon-box">
              <v-icon class="booking">mdi-book-account</v-icon>
            </div>
            <div>{{ $t('booking.booking') }}</div>
            <template v-if="!isLoading && dataAreaPrepare">
              <div class="h-number">{{ $helper.toArabic(dataAreaPrepare.countNumOfAreaBooking || 0) }}</div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>{{ $t('booking.booking_not_enter_stall', { count: $helper.toArabic(dataAreaPrepare.countNumOfAreaBooking || 0) }) }}</div>
                </v-tooltip>{{ $t('area.waiting_enter_stall') }}
              </div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
        </div>
        <div class="dashboard">
          <div class="dashboard-header">
            <div class="head">{{ $t('income.title') }}</div>
            <div>{{ $t('income.income_in_month') }}</div>
            <div class="select-month-year">
              <SelectMonthYear :isDisabled="isLoading" :startMonth="startMonth" :startYear="startYear" isOnChange
                @onSelect="onSelectMonthYear" />
            </div>
            <div class="tail">
              <div>{{ $t('invoice.invoice_data') }}</div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                <div>{{ $t('invoice.invoice_data_by_document_date_in_month') }}</div>
              </v-tooltip>
            </div>
          </div>
          <div class="dashboard-box">
            <div class="icon-box">
              <v-icon class="cash">mdi-cash-multiple</v-icon>
            </div>
            <div>{{ $t('income.title') }}</div>
            <template v-if="!isLoading && dataIncomePrepare">
              <div class="h-number">
                {{ (currentIncomePrepare ? currentIncomePrepare.totalValue || 0 : 0) | currencyPrefixSign(null, { isAbbreviate: true }) }}
              </div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div v-if="currentIncomePrepare">{{ $t('income.income_in_month') }} {{ currentIncomePrepare.monthYear }} :
                      {{ currentIncomePrepare.totalValue || 0 | currencyPrefixSign }}</div>
                    <div>{{ $t('income.total_income', { count: $options.filters.currencyPrefixSign(dataIncomePrepare.totalValue || 0) }) }}</div>
                  </div>
                </v-tooltip>
                {{ $t('all') }} {{ dataIncomePrepare.totalValue | currencyPrefixSign(null, { isAbbreviate: true }) }} 
              </div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
          <div class="dashboard-box">
            <div class="icon-box">
              <v-icon class="bill">mdi-file-document-outline</v-icon>
            </div>
            <div>{{ $t('bill.bill') }}</div>
            <template v-if="!isLoading && dataIncomePrepare">
              <div class="h-number">
                {{ (currentIncomePrepare ? currentIncomePrepare.count || 0 : 0) }} 
                <span> {{ $t('bill.bill') }}</span>
              </div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div v-if="currentIncomePrepare">{{ $t('bill.bill_in_month') }} {{ currentIncomePrepare.monthYear }} :
                      {{ $helper.toArabic(currentIncomePrepare.count || 0) }} {{ $t('bill.bill') }}</div>
                    <div>{{ $t('bill.total_bill', { count: $helper.toArabic(dataIncomePrepare.count || 0) }) }}</div>
                    <div v-if="currentIncomePrepare">{{ $t('income.minimum_income', { count: $options.filters.currencyPrefixSign(currentIncomePrepare.minTotalValue || 0) }) }}
                    </div>
                    <div v-if="currentIncomePrepare">{{ $t('income.maximum_income', { count: $options.filters.currencyPrefixSign(currentIncomePrepare.maxTotalValue || 0) }) }}
                    </div>
                    <div v-if="currentIncomePrepare">{{ $t('income.average_income', { count: $options.filters.currencyPrefixSign(currentIncomePrepare.avgTotalValue || 0) }) }}
                    </div>
                  </div>
                </v-tooltip>
                {{ $t('bill.total_bill_all', { count: $helper.toArabic(dataIncomePrepare.count || 0) }) }}
              </div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
          <div class="dashboard-box">
            <div class="icon-box">
              <v-icon class="discount">mdi-sale</v-icon>
            </div>
            <div>{{ $t('discount') }}</div>
            <template v-if="!isLoading && dataIncomePrepare">
              <div class="h-number">
                {{ (currentIncomePrepare ? currentIncomePrepare.totalDiscountValue || 0 : 0) | currencyPrefixSign(null, { isAbbreviate: true }) }}
                <!-- {{dataIncomePrepare.totalDiscountValue | currency}} -->
                <span>{{ $helper.currencySign() }}</span>
              </div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div v-if="currentIncomePrepare">{{ $t('payment.discount_in_month') }} {{ currentIncomePrepare.monthYear }} :
                      {{ currentIncomePrepare.totalDiscountValue || 0 | currencyPrefixSign }}</div>
                    <div>{{ $t('payment.total_discount', { count: $options.filters.currencyPrefixSign(dataIncomePrepare.totalDiscountValue || 0) }) }}</div>
                  </div>
                </v-tooltip>
                {{ $t('all') }} {{ dataIncomePrepare.totalDiscountValue | currencyPrefixSign(null, { isAbbreviate: true }) }} 
              </div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
        </div>
        <div class="dashboard">
          <div class="dashboard-header">
            <div class="head">{{ $t('product.title') }}</div>
            <div>{{ $t('area.current_stall') }}</div>
            <div class="tail">{{ $t('area.stall_data') }}</div>
          </div>
          <div class="dashboard-box product">
            <div class="icon-box">
              <v-icon class="product">mdi-storefront-outline</v-icon>
            </div>
            <div>{{ $t('product.best_seller_product') }}</div>
            <template v-if="!isLoading && dataAreaPrepare && dataAreaPrepare.countProductTop">
              <div class="h-text">{{ dataAreaPrepare.countProductTop.name }}</div>
              <div class="h-number">
                {{ $helper.toArabic(dataAreaPrepare.countProductTop.count || 0) }}
                <span>({{ $helper.toCurrency(dataAreaPrepare.countProductTop.percent || 0) }}%)</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div>{{ $t('product.best_seller_product_is', { count: dataAreaPrepare.countProductTop.name }) }}</div>
                    <div>{{ $t('product.total_product_in_market', { count: $helper.toArabic(dataAreaPrepare.countProductTop.count || 0) }) }}</div>
                    <div>{{ $t('area.renter_percentage_of_total_stall', { count: $helper.toCurrency(dataAreaPrepare.countProductTop.percent || 0) }) }}
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </template>
            <div v-else class="pt-5">{{ $t('noinfo') }}</div>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
          <div class="dashboard-box product">
            <div class="icon-box">
              <v-icon class="product-type">mdi-store</v-icon>
            </div>
            <div>{{ $t('product.best_seller_product_type') }}</div>
            <template v-if="!isLoading && dataAreaPrepare && dataAreaPrepare.countProductByTypeTop">
              <div class="h-text">{{ dataAreaPrepare.countProductByTypeTop.name }}</div>
              <div class="h-number">
                {{ $helper.toArabic(dataAreaPrepare.countProductByTypeTop.countArea || 0) }}
                <span>({{ $helper.toCurrency(dataAreaPrepare.countProductByTypeTop.percent || 0) }}%)</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div>{{ $t('product.best_seller_product_type_is', { count: dataAreaPrepare.countProductByTypeTop.name }) }}</div>
                    <div>{{ $t('product.total_product_in_market', { count: $helper.toArabic(dataAreaPrepare.countProductByTypeTop.countArea || 0) }) }}</div>
                    <div>{{ $t('area.renter_percentage_of_total_stall', { count: $helper.toCurrency(dataAreaPrepare.countProductByTypeTop.percent || 0) }) }}</div>
                  </div>
                </v-tooltip>
              </div>
            </template>
            <div v-else class="pt-5">{{ $t('noinfo') }}</div>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
          <div class="dashboard-box product">
            <div class="icon-box">
              <v-icon class="product-nodata">mdi-storefront-remove-outline</v-icon>
            </div>
            <div>{{ $t('noitem') }}</div>
            <template v-if="!isLoading && dataAreaPrepare && dataAreaPrepare.countProductObject">
              <div class="h-number">
                {{ $helper.toArabic(dataAreaPrepare.countProductObject.noData.count || 0) }}
                <span>({{ $helper.toCurrency(dataAreaPrepare.countProductObject.noData.percent || 0) }}%)</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  <div>
                    <div>{{ $t('area.total_stall_without_product', { count: $helper.toArabic(dataAreaPrepare.countProductObject.noData.count || 0) }) }}</div>
                    <div>{{ $t('area.renter_percentage_of_total_stall', { count: $helper.toCurrency(dataAreaPrepare.countProductObject.noData.percent || 0) }) }}</div>
                  </div>
                </v-tooltip>
              </div>
            </template>
            <v-progress-circular v-if="isLoading" indeterminate color="primary" size="25"></v-progress-circular>
          </div>
        </div>

        <div class="barchart-income">
          <canvas :id="`bar-chart-overview-income-${tabType}`"
            v-show="dataIncomePrepare && dataIncomePrepare.monthYear && dataIncomePrepare.monthYear.length && !isLoading"></canvas>
          <div class="no-data"
            v-if="!(dataIncomePrepare && dataIncomePrepare.monthYear && dataIncomePrepare.monthYear.length) || isLoading">
            <div v-if="!isLoading">{{ $t('no_income') }}</div>
            <v-progress-circular v-else indeterminate color="primary" size="64"></v-progress-circular>
          </div>
        </div>
        <div class="barchart-income">
          <canvas :id="`bar-chart-overview-income-yoy-${tabType}`"
            v-show="dataIncomePrepare && dataIncomePrepare.monthYear && dataIncomePrepare.monthYear.length && !isLoading"></canvas>
          <div class="no-data"
            v-if="!(dataIncomePrepare && dataIncomePrepare.monthYear && dataIncomePrepare.monthYear.length) || isLoading">
            <div v-if="!isLoading">{{ $t('no_income') }}</div>
            <v-progress-circular v-else indeterminate color="primary" size="64"></v-progress-circular>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import SelectMonthYear from "@/components/SelectMonthYear.component";
Chart.register(ChartDataLabels);
let barChartOverviewIncome, barChartOverviewIncomeYoY;
export default {
  props: {
    isMainLoading: Boolean,
    tabType: {
      type: String,
      default: "THB"
    }
  },
  components: {
    SelectMonthYear
  },
  computed: {
    ...mapGetters({
      market: "markets/getMarket",
      incomeOverall: "invoice/getInvoiceOverall",
      areaOverall: "area/getOverallAreas"
    })
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      dataIncomes: null,
      dataAreas: null,
      currentMonthYear: null,
      dataIncomePrepare: null,
      currentIncomePrepare: null,
      dataAreaPrepare: null,
      currentAreaPrepare: null,
      isMountedCheckBarChartOverviewIncome: false,
      isMountedCheckBarChartOverviewIncomeYoY: false,
      startMonth: parseFloat(this.$moment().format("M")),
      startYear: parseFloat(this.$moment().format("YYYY")),
      tab: this.$globalCurrencyCode
    };
  },
  mounted() {
    this.isMountedCheckBarChartOverviewIncome = true;
    this.isMountedCheckBarChartOverviewIncomeYoY = true;
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      if (!this.currentMonthYear)
        this.currentMonthYear = {
          month: this.startMonth,
          year: this.startYear
        };
      try {
        this.dataIncomes = await this.getOverAllInvoices();
        this.dataAreas = await this.getOverallAreas();
        this.dataIncomePrepare = await this.prepareDataOverviewIncome(
          this.dataIncomes.sort(
            (a, b) =>
              this.$moment(a.objectId, "MM/YYYY") -
              this.$moment(b.objectId, "MM/YYYY")
          )
        );
        this.dataAreaPrepare = await this.prepareDataOverviewArea(
          this.dataAreas
        );
        this.onSelectMonthYear(this.currentMonthYear);
        //Create chart
        this.initBarChartMonthlyIncome(this.dataIncomePrepare);
        this.initBarChartMonthlyIncomeYoY(this.dataIncomePrepare);
        this.isLoading = false;
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isLoading = false;
      }
    },
    onSelectMonthYear(val) {
      this.currentMonthYear = val;
      if (
        this.dataIncomePrepare &&
        this.dataIncomePrepare.monthYear &&
        this.dataIncomePrepare.monthYear.length
      ) {
        let monthYear = this.$moment(
          `${this.currentMonthYear.month}/${this.currentMonthYear.year}`,
          "M/YYYY"
        );
        let dataIncome = this.dataIncomePrepare.monthYear.find(
          d => d.objectId == monthYear.format("MM/YYYY")
        );
        if (dataIncome) {
          dataIncome.monthYear = monthYear.format("MMMM YYYY");
          this.currentIncomePrepare = dataIncome;
        } else
          this.currentIncomePrepare = {
            monthYear: monthYear.format("MMMM YYYY")
          };
      }
      if (this.dataAreaPrepare) {
        this.currentAreaPrepare = [];
      }
    },
    getOverAllInvoices() {
      return this.$store.dispatch("invoice/getOverAllInvoices", {
        projectId: this.projectId,
        marketId: this.marketId
      });
    },
    getOverallAreas() {
      return this.$store.dispatch("area/getOverallAreas", {
        projectId: this.projectId,
        marketId: this.marketId
      });
    },
    prepareDataOverviewIncome(dataIncomes) {
      let dataRes = {
        monthYear: [],
        count: 0,
        totalDiscountNonVatValue: 0,
        totalDiscountValue: 0,
        totalDiscountVatValue: 0,
        totalNonVatItemsValue: 0,
        totalNonVatValue: 0,
        totalPaidValue: 0,
        totalValue: 0,
        totalVatItemsValue: 0,
        totalVatValue: 0,
        totalWhtValue: 0,
        avgTotalValue: 0,
        lastMonth: "",
        lastMonthTotalValue: 0,
        lastMonthTotalDiscountValue: 0,
        lastMonthCount: 0,
        maxTotalValue: Math.max(...dataIncomes.map(o => o.maxTotalValue)),
        minTotalValue: Math.min(...dataIncomes.map(o => o.minTotalValue))
      };
      if (dataIncomes && dataIncomes.length) {
        let dataIncomeObjects = {};
        for (const dataIncome of dataIncomes) {
          dataIncomeObjects[dataIncome.objectId] = dataIncome;
        }
        let minimumMonths = 24;
        let monthYearStop = this.$moment(
          dataIncomes[dataIncomes.length - 1].objectId,
          "MM/YYYY"
        );
        let monthYearStart = this.$moment(dataIncomes[0].objectId, "MM/YYYY");
        let monthYearNumber = monthYearStop.diff(monthYearStart, "months");
        for (
          let numberOfMonth = 0;
          numberOfMonth <=
          (monthYearNumber < minimumMonths ? minimumMonths : monthYearNumber);
          numberOfMonth++
        ) {
          let monthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth, "months")
            .format("MM/YYYY");
          let bfMonthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth - 1, "months")
            .format("MM/YYYY");
          let aYearAgoMonthYear = this.$moment(monthYearStop)
            .add(
              monthYearNumber < minimumMonths
                ? -minimumMonths
                : -monthYearNumber,
              "months"
            )
            .add(numberOfMonth - 12, "months")
            .format("MM/YYYY");
          let dataIncome = dataIncomeObjects[monthYear];
          let bfDataIncome = dataIncomeObjects[bfMonthYear];
          let aYearAgoDataIncome = dataIncomeObjects[aYearAgoMonthYear];
          if (dataIncome) {
            dataIncome.revenueGrowth = bfDataIncome
              ? (dataIncome.totalValue - bfDataIncome.totalValue) /
              bfDataIncome.totalValue
              : 0;
            dataIncome.differenceIncomePrevious = bfDataIncome
              ? dataIncome.totalValue - bfDataIncome.totalValue
              : dataIncome.totalValue;
            dataIncome.differenceYearIncome = aYearAgoDataIncome
              ? dataIncome.totalValue - aYearAgoDataIncome.totalValue
              : dataIncome.totalValue;
            dataIncome.bfYearIncome = aYearAgoDataIncome
              ? aYearAgoDataIncome.totalValue
              : 0;
            dataIncome.aYearAgoMonthYear = aYearAgoMonthYear;
            dataRes.monthYear.push(dataIncome);
            dataRes.count += dataIncome.count;
            dataRes.totalDiscountNonVatValue +=
              dataIncome.totalDiscountNonVatValue;
            dataRes.totalDiscountValue += dataIncome.totalDiscountValue;
            dataRes.totalDiscountVatValue += dataIncome.totalDiscountVatValue;
            dataRes.totalNonVatItemsValue += dataIncome.totalNonVatItemsValue;
            dataRes.totalNonVatValue += dataIncome.totalNonVatValue;
            dataRes.totalPaidValue += dataIncome.totalPaidValue;
            dataRes.totalValue += dataIncome.totalValue;
            dataRes.totalVatItemsValue += dataIncome.totalVatItemsValue;
            dataRes.totalVatValue += dataIncome.totalVatValue;
            dataRes.totalWhtValue += dataIncome.totalWhtValue;
            dataRes.avgTotalValue += dataIncome.avgTotalValue;
            if (monthYear == monthYearStop.format("MM/YYYY")) {
              dataRes.lastMonth = this.$moment(
                dataIncome.objectId,
                "MM/YYYY"
              ).format("MMMM YYYY");
              dataRes.lastMonthTotalValue = dataIncome.totalValue;
              dataRes.lastMonthCount = dataIncome.count;
              dataRes.lastMonthTotalDiscountValue =
                dataIncome.totalDiscountValue;
            }
          } else {
            dataRes.monthYear.push({
              avgTotalValue: 0,
              count: 0,
              differenceIncomePrevious: bfDataIncome
                ? 0 - bfDataIncome.totalValue
                : 0,
              differenceYearIncome: aYearAgoDataIncome
                ? 0 - aYearAgoDataIncome.totalValue
                : 0,
              bfYearIncome: aYearAgoDataIncome
                ? aYearAgoDataIncome.totalValue
                : 0,
              maxTotalValue: 0,
              minTotalValue: 0,
              objectId: monthYear,
              revenueGrowth: bfDataIncome
                ? (0 - bfDataIncome.totalValue) / bfDataIncome.totalValue
                : 0,
              totalDiscountNonVatValue: 0,
              totalDiscountValue: 0,
              totalDiscountVatValue: 0,
              totalNonVatItemsValue: 0,
              totalNonVatValue: 0,
              totalPaidValue: 0,
              totalValue: 0,
              totalVatItemsValue: 0,
              totalVatValue: 0,
              totalWhtValue: 0
            });
          }
        }
        dataRes.avgTotalValue = dataRes.avgTotalValue / dataIncomes.length;
      }
      return dataRes;
    },
    prepareDataOverviewArea(dataAreas) {
      let dataRes = {
        monthYearStay: {},
        monthYearStayArr: [],
        count: 0,
        countOccupied: 0,
        percentOccupied: 0,
        countContract: 0,
        countAreaBooking: 0,
        countContractAreaBooking: 0,
        countNumOfAreaBooking: 0,
        lastMonth: "",
        lastMonthData: undefined,
        size: 0,
        countProductObject: {
          noData: { count: 0, name: this.$t('no_specify_product'), percent: 0, countArea: {} }
        },
        countProductByTypeObject: {
          noData: { count: 0, name: this.$t('no_specify_product'), percent: 0, countArea: {} }
        },
        countProduct: [],
        countProductByType: [],
        countProductTop: null,
        countProductByTypeTop: null
      };
      if (dataAreas && dataAreas.length) {
        for (let dataArea of dataAreas) {
          dataRes.count++;
          dataRes.size += dataArea.size || 0;
          dataRes.countNumOfAreaBooking += dataArea.numOfAreaBooking || 0;
          if (dataArea.areaBooking || dataArea.contract) {
            dataRes.countOccupied++;
            if (dataArea.areaBooking && dataArea.contract) {
              dataRes.countContractAreaBooking++;
            }
            if (dataArea.contract) {
              dataRes.countContract++;
              let monthYearContract = dataArea.contract
                ? this.$moment(dataArea.contract.startDate.iso).format(
                  "MM/YYYY"
                )
                : "";
              if (!dataRes.monthYearStay[monthYearContract])
                dataRes.monthYearStay[monthYearContract] = {
                  countAreaBooking: 0,
                  countContract: 0,
                  count: 0
                };
              dataRes.monthYearStay[monthYearContract].countContract++;
              dataRes.monthYearStay[monthYearContract].count++;
            }
            if (dataArea.areaBooking) {
              dataRes.countAreaBooking++;
              let monthYearAreaBooking = dataArea.areaBooking
                ? this.$moment(dataArea.areaBooking.startDate.iso).format(
                  "MM/YYYY"
                )
                : "";

              if (!dataRes.monthYearStay[monthYearAreaBooking])
                dataRes.monthYearStay[monthYearAreaBooking] = {
                  countAreaBooking: 0,
                  countContract: 0,
                  count: 0
                };
              dataRes.monthYearStay[monthYearAreaBooking].countAreaBooking++;
              dataRes.monthYearStay[monthYearAreaBooking].count++;
            }
            if (dataArea.products && dataArea.products.length) {
              for (const product of dataArea.products) {
                if (!dataRes.countProductObject[product.objectId])
                  dataRes.countProductObject[product.objectId] = {
                    count: 0,
                    countArea: {},
                    percent: 0,
                    name: product.name
                  };
                dataRes.countProductObject[product.objectId].count++;
                dataRes.countProductObject[product.objectId].countArea[
                  dataArea.id
                ] = true;
                if (
                  product.productCategory && product.productCategory.objectId &&
                  !dataRes.countProductByTypeObject[
                  product.productCategory.objectId
                  ]
                ) {
                  dataRes.countProductByTypeObject[
                    product.productCategory.objectId
                  ] = {
                    count: 0,
                    countArea: {},
                    percent: 0,
                    name: product.productCategory.name
                  };
                }
                if (product.productCategory && product.productCategory.objectId) {

                  dataRes.countProductByTypeObject[
                    product.productCategory.objectId
                  ].count++;
                  dataRes.countProductByTypeObject[
                    product.productCategory.objectId
                  ].countArea[dataArea.id] = true;
                }
              }
            } else {
              dataRes.countProductObject.noData.count++;
              dataRes.countProductByTypeObject.noData.count++;

              dataRes.countProductObject.noData.countArea[dataArea.id] = true;
              dataRes.countProductByTypeObject.noData.countArea[
                dataArea.id
              ] = true;
            }
          }
        }
        for (const monthYear in dataRes.monthYearStay) {
          let dataTemp = dataRes.monthYearStay[monthYear];
          dataTemp.monthYear = monthYear;
          dataRes.monthYearStayArr.push(dataTemp);
        }
        for (const productObjectId in dataRes.countProductObject) {
          let dataTemp = dataRes.countProductObject[productObjectId];
          dataTemp.objectId = productObjectId;
          dataTemp.countArea = Object.keys(dataTemp.countArea).length;
          dataTemp.percent = (dataTemp.countArea / dataRes.countOccupied) * 100;
          dataRes.countProduct.push(dataTemp);
        }
        for (const productObjectId in dataRes.countProductByTypeObject) {
          let dataTemp = dataRes.countProductByTypeObject[productObjectId];
          dataTemp.objectId = productObjectId;
          dataTemp.countArea = Object.keys(dataTemp.countArea).length;
          dataTemp.percent = (dataTemp.countArea / dataRes.countOccupied) * 100;
          dataRes.countProductByType.push(dataTemp);
        }
        dataRes.monthYearStayArr.sort(
          (a, b) =>
            this.$moment(a.monthYear, "MM/YYYY") -
            this.$moment(b.monthYear, "MM/YYYY")
        );
        dataRes.countProduct.sort((a, b) => b.count - a.count);
        dataRes.countProductByType.sort((a, b) => b.count - a.count);
        dataRes.countProductTop = dataRes.countProduct[0];
        dataRes.countProductByTypeTop = dataRes.countProductByType[0];

        let monthYearStop = dataRes.monthYearStayArr.length
          ? this.$moment(
            dataRes.monthYearStayArr[dataRes.monthYearStayArr.length - 1]
              .monthYear,
            "MM/YYYY"
          )
          : null;
        dataRes.lastMonthData =
          dataRes.monthYearStayArr[dataRes.monthYearStayArr.length - 1];
        dataRes.lastMonth = monthYearStop
          ? monthYearStop.format("MMMM YYYY")
          : "-";
        dataRes.percentOccupied = dataRes.countOccupied / dataRes.count;
      }
      return dataRes;
    },
    initBarChartMonthlyIncome(dataIncomePrepare) {
      let _this = this;
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          layout: {
            padding: {
              // top:50
            }
          },
          scales: {
            y: {
              ticks: {
                callback: function (value, index, ticks) {
                  return (
                    `${_this.$helper.currencySign()}` +
                    parseFloat(value)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  );
                }
              }
            },
            y1: {
              display: false,
              type: "linear",
              position: "right",
              beginAtZero: true
            }
          },
          plugins: {
            labels: {
              render: "value"
            },
            title: {
              text: this.$t('income.income_and_growth_rate_chart'),
              display: true
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (context) {
                  let text;
                  if (context.datasetIndex == 0) {
                    text = `${context.dataset.label} : ${_this.$helper.currencySign()}${parseFloat(
                      context.raw || 0
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
                  } else if (context.datasetIndex == 1) {
                    text = `${context.dataset.label} : ${(
                      parseFloat(context.raw) * 100
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%`;
                  }
                  return text;
                },
                footer: context => {
                  let text;
                  let dataIncome = this.dataIncomePrepare.monthYear.find(
                    d => d.objectId == context[0].label
                  );
                  if (dataIncome)
                    text = `${this.$t('market.rental_income_difference_from_previous_month')}: ${
                      _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isShowPlus: true, isPrefixSign: true, isNoSpace: true, mathType : "outSide" })
                    }`;
                  return text;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              // textShadowColor:'#FFFFFF',

              color: function (context) {
                let color = "#00000099";
                if (context.datasetIndex == 0) {
                  color = `#00000099`;
                } else if (context.datasetIndex == 1) {
                  color =
                    context.dataset.data[context.dataIndex] >= 0
                      ? `#17dd95D0`
                      : `#F25C5DD0`;
                }
                return color;
              },
              formatter: (val, context) => {
                let text;
                let dataIncome = this.dataIncomePrepare.monthYear.find(
                  d =>
                    d.objectId == context.chart.data.labels[context.dataIndex]
                );
                if (context.datasetIndex == 0) {
                  text = `${this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true})} `;
                } else if (context.datasetIndex == 1) {
                  text = `${
                    this.$helper.toCurrency((parseFloat(val) * 100), null, { isShowPlus: true, mathType : "outSide" })
                    }%${dataIncome
                      ? "\n" + this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true , mathType : "outSide"})
                      : ""
                    }`;
                }
                return text;
              }
            }
          }
        },
        plugins: [
          ChartDataLabels,
          {
            id: "legendMargin",
            beforeInit: function (chart, options) {
              const fitValue = chart.legend.fit;
              chart.legend.fit = function fit() {
                fitValue.bind(chart.legend)();
                return (this.height += 40);
              };
            }
          }
        ]
      };
      dataChart.data.labels = [];
      dataChart.data.datasets[0] = {
        label: this.$t('income.summary_income'),
        type: "bar",
        data: [],
        backgroundColor: ["#5fffd740"],
        borderColor: ["#5fffd7"],
        borderWidth: 1,
        order: 1
      };
      dataChart.data.datasets[1] = {
        label: this.$t('income.growth_rate_of_income'),
        type: "line",
        data: [],
        backgroundColor: "rgb(255, 239, 149)",
        borderColor: "rgba(255, 221, 30, 0.5)",
        tension: 0.3,
        fill: false,
        yAxisID: "y1",
        order: 0
      };

      for (const index in dataIncomePrepare.monthYear) {
        if (dataIncomePrepare.monthYear.length - index <= 12) {
          let dataIncome = dataIncomePrepare.monthYear[index];
          dataChart.data.labels.push(dataIncome.objectId);
          dataChart.data.datasets[0].data.push(dataIncome.totalValue);
          dataChart.data.datasets[1].data.push(dataIncome.revenueGrowth);
        }
      }
      if (
        !barChartOverviewIncome ||
        this.isMountedCheckBarChartOverviewIncome
      ) {
        var ctx = document.getElementById(`bar-chart-overview-income-${this.tabType}`);
        if (ctx) barChartOverviewIncome = new Chart(ctx, dataChart);
        this.isMountedCheckBarChartOverviewIncome = false;
      } else {
        barChartOverviewIncome.update();
      }
    },
    initBarChartMonthlyIncomeYoY(dataIncomePrepare) {
      let _this = this;
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          layout: {
            padding: {
              // top:50
            }
          },
          scales: {
            y: {
              ticks: {
                callback: function (value, index, ticks) {
                  return `${_this.$helper.toCurrency(parseFloat(value), null, { isPrefixSign: true, isNoSpace: true })}`;
                }
              }
            },
            y1: {
              display: false,
              type: "linear",
              position: "right",
              beginAtZero: true
            }
          },
          plugins: {
            labels: {
              render: "value"
            },
            title: {
              text: this.$t('income.income_change_over_year_chart_graph'),
              display: true
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (context) {
                  let text;
                  if (context.datasetIndex == 0) {
                    text = `${context.dataset.label} : ${
                      _this.$helper.toCurrency(parseFloat(context.raw || 0), null, { isPrefixSign: true, isShowPlus: true, isNoSpace: true, mathType : "outSide" })
                    }`;
                  } else if (context.datasetIndex == 1) {
                    text = `${context.dataset.label} : ${
                      _this.$helper.toCurrency((parseFloat(context.raw) * 100), null, { isPrefixSign: true, isShowPlus: true, isNoSpace: true, mathType : "outSide" })
                    }%`;
                  }
                  return text;
                },
                footer: context => {
                  let text;
                  let dataIncome = this.dataIncomePrepare.monthYear.find(
                    d => d.objectId == context[0].label
                  );
                  if (dataIncome)
                    text = `${this.$t('market.income_from')} ${context[0].label} : ${
                      _this.$helper.toCurrency(parseFloat(dataIncome.totalValue || 0), null, { isPrefixSign: true })
                    }\n${this.$t('market.income_from')} ${dataIncome.aYearAgoMonthYear
                      } : ${_this.$helper.toCurrency(parseFloat(dataIncome.bfYearIncome || 0), null, { isPrefixSign: true })}`;
                  return text;
                }
              }
            },
            datalabels: {
              align: "top",
              anchor: "end",
              padding: {
                // top:150
              },
              font: {
                size: 15,
                weight: "bold"
              },
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              // textShadowColor:'#FFFFFF',

              color: function (context) {
                let color = "#00000099";
                if (context.datasetIndex == 0) {
                  color =
                    context.dataset.data[context.dataIndex] == 0
                      ? `#00000099`
                      : context.dataset.data[context.dataIndex] > 0
                        ? `#17dd95D0`
                        : `#F25C5DD0`;
                } else if (context.datasetIndex == 1) {
                  color =
                    context.dataset.data[context.dataIndex] >= 0
                      ? `#5fff5fD0`
                      : `#F25C5DD0`;
                }
                return color;
              },
              formatter: (val, context) => {
                let text;
                let dataIncome = this.dataIncomePrepare.monthYear.find(
                  d =>
                    d.objectId == context.chart.data.labels[context.dataIndex]
                );
                if (context.datasetIndex == 0) {
                  text = `${
                    _this.$helper.toCurrency(parseFloat(val || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType : "outSide" })
                  }`;
                } else if (context.datasetIndex == 1) {
                  text = `${
                    _this.$helper.toCurrency((parseFloat(val) * 100), null, { isShowPlus: true, mathType : "outSide" })
                    }%${dataIncome
                      ? "\n" + _this.$helper.toCurrency(parseFloat(dataIncome.differenceIncomePrevious || 0), null, { isAbbreviate: true, isPrefixSign: true, isShowPlus: true, mathType : "outSide" })
                      : ""
                  }`;
                }
                return text;
              }
            }
          }
        },
        plugins: [
          ChartDataLabels,
          {
            id: "legendMargin",
            beforeInit: function (chart, options) {
              const fitValue = chart.legend.fit;
              chart.legend.fit = function fit() {
                fitValue.bind(chart.legend)();
                return (this.height += 20);
              };
            }
          }
        ]
      };
      dataChart.data.labels = [];
      dataChart.data.datasets[0] = {
        label: this.$t('income.income_change'),
        type: "bar",
        data: [],
        backgroundColor: "#ffdcb570",
        borderColor: "#ffa33a",
        borderWidth: 1,
        order: 1
      };
      // dataChart.data.datasets[1] = {
      //   label: "อัตราการเติบโตของรายได้",
      //   type: "line",
      //   data: [],
      //   backgroundColor: "rgb(255, 239, 149)",
      //   borderColor: "rgba(255, 221, 30, 0.5)",
      //   tension: 0.3,
      //   fill: false,
      //   yAxisID: "y1",
      //   order: 0
      // };

      for (const index in dataIncomePrepare.monthYear) {
        if (dataIncomePrepare.monthYear.length - index <= 12) {
          let dataIncome = dataIncomePrepare.monthYear[index];
          dataChart.data.labels.push(dataIncome.objectId);
          dataChart.data.datasets[0].data.push(dataIncome.differenceYearIncome);
          // dataChart.data.datasets[1].data.push(dataIncome.revenueGrowth);
        }
      }
      if (
        !barChartOverviewIncomeYoY ||
        this.isMountedCheckBarChartOverviewIncomeYoY
      ) {
        var ctx = document.getElementById(`bar-chart-overview-income-yoy-${this.tabType}`);
        if (ctx) barChartOverviewIncomeYoY = new Chart(ctx, dataChart);
        this.isMountedCheckBarChartOverviewIncomeYoY = false;
      } else {
        barChartOverviewIncomeYoY.update();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.v-card__text {
  display: flex;
  flex-flow: row wrap;
  margin: 0;
  gap: 15px;

  .dashboard {
    display: flex;
    background: rgba(230, 230, 230, 0.35);
    border-radius: 15px;
    height: fit-content;
    min-height: 186px;

    .dashboard-header {
      padding: 25px;
      min-width: 202px;

      .head {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }

      .tail {
        display: inline-flex;
        font-style: italic;
        color: rgba(128, 128, 128, 0.527);
        align-items: center;

        i {
          margin-left: 2px;
          font-size: 15px;
          color: rgba(128, 128, 128, 0.527);
        }
      }

      .select-month-year {
        max-width: 200px;
        margin: 10px 0;
      }
    }

    .dashboard-box {
      width: 180px;
      // border: 1px solid rgb(167, 167, 167);
      // border-radius: 15px;
      padding: 10px 20px;
      // margin: 0 15px;
      font-size: 15px;

      .h-number {
        font-size: 30px;
        padding: 10px 0 5px;

        span {
          font-size: 15px;
        }

        i {
          vertical-align: baseline;
          padding-left: 5px;
        }
      }

      .h-text {
        font-size: 20px;
      }

      i {
        font-size: 15px;
      }

      .icon-box {
        display: inline-flex;
        padding: 5px 0 15px 0;

        i {
          color: #ffffff;
          font-size: 30px;
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }

        i.cash {
          background: #5d87ff;
        }

        i.bill {
          background: #27c5da;
        }

        i.discount {
          background: #f9896b;
        }

        i.booking {
          background: #ffaf1d;
        }

        i.renter {
          background: #17dd95;
          // background: #ffa33a;
        }

        i.area {
          background: #4abeff;
        }

        i.product {
          background: #ff4aba;
        }

        i.product-type {
          background: #4a56ff;
        }

        i.product-nodata {
          background: #ff4a4a;
        }

        .image-icon {
          box-shadow: 0 4px 4px -2px gray;
          border-radius: 50%;
          padding: 10px;
        }

        .image-icon.area {
          background: #4abeff;

          img {
            padding: 4px;
            width: 30px;
            object-fit: contain;
            object-position: center;
          }
        }
      }

      span.plus {
        // font-weight: bold;
        font-size: 18px;
        color: rgb(45, 192, 0);
      }
    }

    .dashboard-box.product {
      min-width: 250px;
      width: 100%;
    }

    .dashboard-input {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-right: 15px;
    }
  }

  .dashboard.area {
    width: 100%;
    height: fit-content;
  }

  .barchart-income {
    margin: 20px 15px;

    canvas {
      width: auto;
      max-width: calc(100vw - 24px - 32px - 20px);
      min-height: 30vh;
      height: 50vh;
    }

    .no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      background: rgba(211, 211, 211, 0.281);
      border-radius: 15px;
      max-width: calc(100vw - 24px - 32px - 20px);
      width: 1000px;
      min-height: 30vh;
      height: 50vh;
    }
  }
}
</style>